// src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
    title,
    description = "Diocese of Ibadan South, Anglican Communion — proclaiming the Gospel, serving the community, and growing in faith together.",
    image,
    url,
    siteName = "Diocese of Ibadan South - Anglican Communion",
}) {
    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    // Default/fallback image
    const defaultImage = "https://example.com/images/default-banner.jpg";
    const finalImage = image || defaultImage;

    // Auto-generate URL if not provided (client-side only)
    const finalUrl =
        url ||
        (typeof window !== "undefined"
            ? window.location.href
            : "https://ibadansouthanglicandiocese.org.ng");

    return (
        <Helmet>
            {/* Title & Description */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />

            {/* Canonical */}
            {finalUrl && <link rel="canonical" href={finalUrl} />}

            {/* Open Graph */}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            {finalUrl && <meta property="og:url" content={finalUrl} />}
            <meta property="og:site_name" content={siteName} />
            <meta property="og:image" content={finalImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:type" content="website" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content={finalImage} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
}
